import { uniqBy } from 'lodash'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemWorkingStepsSelector =
  ({
    bomItemId,
    preferTreeView,
    getSummaryOfParts,
    includeOwnWorkingSteps,
  }: {
    bomItemId: string
    preferTreeView?: boolean
    getSummaryOfParts?: boolean
    includeOwnWorkingSteps?: boolean
  }) =>
  (state: RootAppState) => {
    if (!bomItemId) return null

    const projectId = state.project.activeProject?.id

    if (projectId === bomItemId) {
      return state.project.activeProject.workingSteps
    }

    const bomItem = bomItemSelector(state, bomItemId, preferTreeView)

    if (!bomItem?.type) {
      return null
    }

    switch (bomItem?.type) {
      case 'Assembly':
        return getSummaryOfParts
          ? uniqBy(
              bomItem.partTypeWorkingStepDtos.concat(
                includeOwnWorkingSteps ? bomItem.assemblyWorkingStepDtos : []
              ),
              (x) => x.primaryWorkingStep
            )
          : bomItem.assemblyWorkingStepDtos
      case 'Row':
        return bomItem.workingSteps
      case 'MaterialHeader':
      case 'RoutingHeader':
        return bomItem.workingStepDtos
    }
  }
